const isMinPerpendicularPileSpace = (space, diameterPile) => (space >= diameterPile*2) ? true : false

const isMinPileSpace = (space, diameterPile) => (space >= diameterPile) ? true : false

export { isMinPerpendicularPileSpace, isMinPileSpace }